import { render, staticRenderFns } from "./SubscriptionBuyButton.vue?vue&type=template&id=6673c308&scoped=true&"
import script from "./SubscriptionBuyButton.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBuyButton.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBuyButton.vue?vue&type=style&index=0&id=6673c308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673c308",
  null
  
)

export default component.exports